<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GuNNtV/tc-custom/9780743434133.jpg?1730494025455" alt="This image is the cover for the book Blood, Fearless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood, Fearless
      </h1>
      <p class="bookDescription body article font2">
        <p>Gaia reconsiders the consequences of her fearlessness when a drug dealer she beat up takes revenge by killing her friend. She becomes inconsolable and reclusive, and her depression turns into a death wish. But Ed’s got a plan to get Gaia caring again. Will it work?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francine Pascal
      </h2>
      
      <p class="authorDescription body article">Francine Pascal is the creator of several bestselling series, including Fearless and Sweet Valley High, which was also made into a television series. She has written several novels, including <I>My First Love and Other Disasters</I>, <I>My Mother Was Never a Kid</I>, and <I>Love &amp; Betrayal &amp; Hold the Mayo</I>. She is also the author of <I>Sweet Valley Confidential: Ten Years Later</I>. She lives in New York and the South of France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon Pulse
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04801443